import detail from './detailMixin.js'
import list from './listMixin.js'

export default {
    detail,
    list
}